import React from 'react';

interface Props {
    value: number;
}

export const Badge = ({value}: Props) => (
    <span className="badge">{value}</span>
)
